<template>
    <generic title="Page Not Found" description="This page was not found"></generic>
</template>

<script>
    import Generic from "@/views/Errors/Generic.vue";

    export default {
        components: {Generic}

    }
</script>